import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ObjectToolbarConfig } from 'src/blocks/object-toolbar';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';
import { addQuestionnaireTemplateUrl } from '@/utils/urls';

const Page: FC = () => {
  const { t } = useTranslation(['common']);
  const title = t('questionnaire_templates.create_title');
  const objectToolbarEnabled = useIsFeatureFlagEnabled('dynamic_forms');
  // Object-level toolbar (CUS-171) — flag-gated, title-only. The create form
  // keeps its own Create / Cancel buttons, so no save disc or relocated actions.
  const toolbarConfig: ObjectToolbarConfig = useMemo(
    () => ({ header: { title } }),
    [title]
  );
  const tabs = useTabs({
    parentType: Parent_Type_Enum.QuestionnaireTemplate,
    hrefRoot: addQuestionnaireTemplateUrl(),
    parent: null,
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={toolbarConfig} />
        ) : undefined
      }
    >
      <ControlledTabs tabs={tabs} variant={'container'} disableSettings />
    </PageLayout>
  );
};

export default Page;
